import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { reportDataList } from "@/api/dataAll/rawData";
import * as echarts from "echarts";
export default {
  name: "registerList",
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        start_time: "",
        end_time: "",
        page_size: 10,
        isRecharge: '',
        page: 1
      },
      exportLoading: false,
      rechargeList: [{
        label: this.$t('hasRechargeYes'),
        value: 1
      }, {
        label: this.$t('hasRechargeNo'),
        value: 2
      }],
      deduplicationList: [{
        label: this.$t('yes'),
        value: 1
      }],
      DynamicList: [// {
      //   label: '日期',
      //   prop: 'date'
      // },
      {
        label: this.$t('gameName'),
        prop: 'game'
      }, {
        label: this.$t('adChannel'),
        prop: 'ad_channel'
      }, {
        label: this.$t('adPlacement'),
        prop: 'ad_placement'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('userId'),
        prop: 'user_id'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: 'serverID',
        prop: 'server_id'
      }, {
        label: this.$t('cumulativeRechargeAmount'),
        prop: 'recharge_amount'
      }, // {
      //   label: '设备ID',
      //   prop: 'device_id'
      // },
      {
        label: this.$t('registerTime'),
        prop: 'timestamps'
      }, {
        label: this.$t('lastLoginTime'),
        prop: 'last_login_time'
      }],
      isSearch: false
    };
  },
  created: function created() {},
  methods: {
    toUserDetail: function toUserDetail(item) {
      var _this = this;

      var menu = JSON.parse(window.localStorage.getItem('Menu'));
      var isauthority = false;
      menu.forEach(function (element) {
        element.son_menu.forEach(function (k) {
          if (k.url.indexOf('gmTool/playerDetails/playerDetails') > -1 && _this.rawData.game_mark.indexOf('royalpirates') > -1 || k.url.indexOf('gmToolNew/playerDetails_yujian/playerDetails_yujian') > -1 && _this.rawData.game_mark.indexOf('yjfm') > -1) {
            isauthority = true;
          }
        });
      });

      if (!isauthority) {
        this.$message.success(this.$t('noPermission'));
      } else {
        if (this.rawData.game_mark.indexOf('royalpirates') > -1) {
          this.$router.push({
            name: 'playerDetails',
            params: item
          });
        } else if (this.rawData.game_mark.indexOf('yjfm') > -1) {
          this.$router.push({
            name: 'playerDetails_yujian',
            params: item
          });
        }
      }
    },
    searchClick: function searchClick() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var data = {
        firstTime: '',
        lastTime: ''
      };

      if (page == 1) {
        this.searchData.page = 1;
      }

      if (page > this.searchData.page) {
        data.lastTime = this.tableData[this.tableData.length - 1] ? this.tableData[this.tableData.length - 1].timestamp : '';
      } else if (page < this.searchData.page) {
        data.firstTime = this.tableData[0] ? this.tableData[0].timestamp : '';
      }

      this.searchData.page = page;
      this.searchData.starttime = this.value2[0] || '';
      this.searchData.endtime = this.value2[1] || '';
      this.reqLoading = true;
      reportDataList(_objectSpread(_objectSpread(_objectSpread({}, this.searchData), data), {}, {
        page: page
      })).then(function (res) {
        if (res.status == 200) {
          _this2.isSearch = true;

          if (!res.data.length && data.lastTime) {
            _this2.$message.success(_this2.$t('lastPageTip'));

            _this2.searchData.page = page - 1;
            return;
          }

          res.data.map(function (item) {
            item.recharge_amount = _this2.$utils.conversion(item.recharge_amount);
            item.last_login_time = item.last_login_time == "1970-01-01 08:00:00" ? '/' : item.last_login_time;
          });
          _this2.tableData = res.data;
          _this2.total = res.data.total;

          _this2.$nextTick(function () {
            _this2.getTableRight();
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      }).catch(function () {
        _this2.searchData.page = page - 1;
      });
    },
    exportdata: function exportdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var columns, reqData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = _toConsumableArray(_this3.DynamicList);
                reqData = JSON.parse(JSON.stringify(_this3.searchData));
                reqData.page_size = '';
                _this3.exportLoading = true;
                reportDataList(reqData).then(function (res) {
                  if (res.status == 200) {
                    res.data.map(function (item) {
                      item.recharge_amount = _this3.$utils.conversion(item.recharge_amount);
                      item.last_login_time = item.last_login_time == "1970-01-01 08:00:00" ? '/' : item.last_login_time;
                    });

                    _this3.$export.excel({
                      columns: columns,
                      data: res.data,
                      title: _this3.$route.meta.title
                    });
                  }
                }).finally(function () {
                  _this3.exportLoading = false;
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};